module.exports = __webpack_public_path__ + "media/images/icon-encounters-8c23e3966aab8b089fdbe7054ef7d824dba6818e1be6a212613fe47d4dae1955.svg";